import React from 'react'
import PropTypes from 'prop-types'

import ButtonSmall from '../ButtonSmall/ButtonSmall'

import styles from './EmptyList.css'

const propTypes = {
    title: PropTypes.node.isRequired,
    message: PropTypes.node.isRequired,
    buttonCaption: PropTypes.node,
    height: PropTypes.number,
    onButtonClick: PropTypes.func,
    buttonTooltipId: PropTypes.string,
}

class EmptyList extends React.PureComponent {
    render() {
        const actionButton = this.props.buttonCaption && (
            <div className={styles.button}>
                <ButtonSmall
                    type="secondary"
                    onClick={this.props.onButtonClick}
                    tooltipId={this.props.buttonTooltipId}
                >
                    {this.props.buttonCaption}
                </ButtonSmall>
            </div>
        )

        const style = {}
        if (this.props.height) style.height = this.props.height

        return (
            <div className={styles.base} style={style}>
                <div className={styles.holder}>
                    <div className={styles.title}>{this.props.title}</div>
                    <div className={styles.message}>{this.props.message}</div>
                    {actionButton}
                </div>
            </div>
        )
    }
}

EmptyList.propTypes = propTypes

export default EmptyList



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/EmptyList/EmptyList.jsx